import * as React from "react"

export const BookmarkFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 17.462-3.97 1.703q-.903.387-1.716-.148-.814-.534-.814-1.503V5.308q0-.758.525-1.283T7.308 3.5h9.384q.758 0 1.283.525t.525 1.283v12.206q0 .969-.814 1.503-.813.535-1.717.148z"
    ></path>
  </svg>
)
